export enum ExclusionLevel {
  Global = 'Global',
  SiteSpecificManual = 'SiteSpecificManual',
  SiteSpecificAutomatic = 'SiteSpecificAutomatic'
}

export enum ExclusionCategory {
  Block = 'Block',
  Ignore = 'Ignore'
}

export enum ExclusionTypeLabel {
  IpAddress = 'Ip Address',
  ServerSideRaId = 'Server Side Cookie',
  // UserAgent = 'UserAgent',
  EmailAddress = 'Email Address',
  PhoneNumber = 'Phone Number',
  RaId = 'Ruler Cookie',
  // EmailDomain = 'EmailDomain',
  LandingPageURL = 'Landing Page URL',
  ReferrerURL = 'Referrer URL'
}

export enum ExclusionType {
  IpAddress = 'IpAddress',
  ServerSideRaId = 'ServerSideRaId',
  // UserAgent = 'UserAgent',
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber',
  RaId = 'RaId',
  // EmailDomain = 'EmailDomain',
  LandingPageURL = 'LandingPageURL',
  ReferrerURL = 'ReferrerURL'
}

export enum ExclusionMatchTarget {
  RemoteAddress = 'RemoteAddress',
  ServerSideRaId = 'ServerSideRaId',
  Device = 'Device',
  UserAgent = 'UserAgent',
  RaId = 'RaId',
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber',
  LandingPageURL = 'LandingPageURL',
  ReferrerURL = 'ReferrerURL'
}

export enum RuleMatchType {
  Equals = 'Equals',
  Contains = 'Contains'
}

const exclusionTypeLabelMap: Record<ExclusionType, ExclusionTypeLabel> = {
  [ExclusionType.IpAddress]: ExclusionTypeLabel.IpAddress,
  [ExclusionType.ServerSideRaId]: ExclusionTypeLabel.ServerSideRaId,
  [ExclusionType.RaId]: ExclusionTypeLabel.RaId,
  [ExclusionType.EmailAddress]: ExclusionTypeLabel.EmailAddress,
  [ExclusionType.PhoneNumber]: ExclusionTypeLabel.PhoneNumber,
  [ExclusionType.LandingPageURL]: ExclusionTypeLabel.LandingPageURL,
  [ExclusionType.ReferrerURL]: ExclusionTypeLabel.ReferrerURL
};

const exclusionTypeLabelToTypeMap: Record<ExclusionTypeLabel, ExclusionType> = {
  [ExclusionTypeLabel.IpAddress]: ExclusionType.IpAddress,
  [ExclusionTypeLabel.ServerSideRaId]: ExclusionType.ServerSideRaId,
  [ExclusionTypeLabel.RaId]: ExclusionType.RaId,
  [ExclusionTypeLabel.EmailAddress]: ExclusionType.EmailAddress,
  [ExclusionTypeLabel.PhoneNumber]: ExclusionType.PhoneNumber,
  [ExclusionTypeLabel.LandingPageURL]: ExclusionType.LandingPageURL,
  [ExclusionTypeLabel.ReferrerURL]: ExclusionType.ReferrerURL
};

const typeMatchTargetMap: Record<ExclusionTypeLabel, ExclusionMatchTarget> = {
  [ExclusionTypeLabel.IpAddress]: ExclusionMatchTarget.RemoteAddress,
  [ExclusionTypeLabel.ServerSideRaId]: ExclusionMatchTarget.ServerSideRaId,
  [ExclusionTypeLabel.RaId]: ExclusionMatchTarget.RaId,
  [ExclusionTypeLabel.EmailAddress]: ExclusionMatchTarget.EmailAddress,
  [ExclusionTypeLabel.PhoneNumber]: ExclusionMatchTarget.PhoneNumber,
  [ExclusionTypeLabel.LandingPageURL]: ExclusionMatchTarget.LandingPageURL,
  [ExclusionTypeLabel.ReferrerURL]: ExclusionMatchTarget.ReferrerURL
};

export { exclusionTypeLabelToTypeMap };
export { exclusionTypeLabelMap };
export { typeMatchTargetMap };
